// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--group-height:47px}.list-enter-active,.list-leave-active{transition:all .3s ease}.list-enter-from,.list-leave-to{opacity:0;transform:translateX(30px)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
